export default __webpack_public_path__ + "static/media/Green-band.358cb60a.svg";